/* eslint-disable no-bitwise */

/* eslint-disable @typescript-eslint/ban-ts-comment */
export const hexToHSL = (H: string) => {
  // Convert hex to RGB first
  let r = 0
  let g = 0
  let b = 0

  if (H.length === 4) {
    // @ts-ignore
    r = `0x${H[1]}${H[1]}`
    // @ts-ignore
    g = `0x${H[2]}${H[2]}`
    // @ts-ignore
    b = `0x${H[3]}${H[3]}`
  } else if (H.length === 7) {
    // @ts-ignore
    r = `0x${H[1]}${H[2]}`
    // @ts-ignore
    g = `0x${H[3]}${H[4]}`
    // @ts-ignore
    b = `0x${H[5]}${H[6]}`
  }
  // Then to HSL
  r /= 255
  g /= 255
  b /= 255
  const cmin = Math.min(r, g, b)
  const cmax = Math.max(r, g, b)
  const delta = cmax - cmin
  let h = 0
  let s = 0
  let l = 0

  if (delta === 0) h = 0
  else if (cmax === r) h = ((g - b) / delta) % 6
  else if (cmax === g) h = (b - r) / delta + 2
  else h = (r - g) / delta + 4

  h = Math.round(h * 60)

  if (h < 0) h += 360

  l = (cmax + cmin) / 2
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1))
  s = +(s * 100).toFixed(0)
  l = +(l * 100).toFixed(0)

  return `${h} ${s}% ${l}%`
}

export const hslToHex = (h: number, s: number, l: number) => {
  l /= 100
  const a = (s * Math.min(l, 1 - l)) / 100
  const f = (n: number) => {
    const k = (n + h / 30) % 12
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1)

    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0') // convert to Hex and prefix "0" if needed
  }

  return `#${f(0)}${f(8)}${f(4)}`
}

export const formatHslString = (value: string) => {
  const arr = value.trimStart().replaceAll('%', '').split(' ')

  return arr
}

export const hlsStringToHex = (hsl: string) => {
  const values = formatHslString(hsl)

  return hslToHex(parseInt(values[0], 10), parseInt(values[1], 10), parseInt(values[2], 10))
}

export const hexToRgbA = (hex: string, opacity: number) => {
  try {
    let c: any

    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('')
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]]
      }
      c = `0x${c.join('')}`

      return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${opacity})`
    }

    return hex
  } catch {
    return hex
  }
}

export const formatPrice = (price: number, fractionalDigits: number) => {
  try {
    const formatPriceVal = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: fractionalDigits
    })

    return formatPriceVal.format(price).toString()
  } catch (e) {
    return price
  }
}

export const calcSignalStrength = (value = -1) => {
  if (Number.isNaN(value)) {
    return 0
  }

  const signalValue = Math.ceil(value / 3)

  if (signalValue < 0) {
    return 0
  }

  return signalValue
}
